import type { DataQaMessage } from '../../services/api/dataQa';

// Servern tar högst 20 meddelanden. Äldre vändor klipps bort hellre än att en lång
// tråd slutar med ett 400-fel; modellen får ändå frågan och de senaste svaren.
export const MAX_HISTORY_MESSAGES = 20;

export const buildHistory = (entries: DataQaMessage[], question: string): DataQaMessage[] =>
  [
    ...entries.map(({ role, content }) => ({ role, content })),
    { role: 'user' as const, content: question },
  ].slice(-MAX_HISTORY_MESSAGES);
